import { FC } from "react";
import { Box } from "../../../styles/basicStyles";
import { colors } from "../../../styles/colors";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { Industry, ProductType, Service, Technology } from "../../../models/work";
import { GenerateSlug } from "../../../utils/slug";
import Typography from "../../../components/typography";

interface Props {
  year?: number;
  services?: Service[];
  industries?: Industry[];
  technologies?: Technology[];
  productTypes?: ProductType[];
}

const Filters: FC<Props> = ({ year, services, industries, technologies, productTypes }) => {
  const { t, i18n: { language } } = useTranslation();
  const router = useRouter();

  const renderTitle = (title: string) => {
    return (
      <Typography
        fSize={{ md: 1.375, xxs: 1.125 }}
        lHeight={{ md: 2.125, xxs: 1.625 }}
        fWeight={700}
        color={colors.black}
        mr={0.5}
      >
        {title}:
      </Typography>
    );
  };

  const renderItem = (value: string, type: string, index: number, total: number) => {
    return (
      <Typography
        key={index}
        fSize={{ md: 1.375, xxs: 1.125 }}
        lHeight={{ md: 2.125, xxs: 1.625 }}
        fWeight={400}
        color={colors.black}
        mr={index === total - 1 ? 0 : 0.5}
        hoverColor={colors.purple}
        onClick={() => router.push(`/work?${type}=${GenerateSlug(value)}`)}
      >
        {`${value}${index < (total - 1) ? ', ' : ''}`}
      </Typography>
    );
  };

  return (
    <>
      {
        (
          !!year ||
          (services && services?.length > 0) ||
          (productTypes && productTypes?.length > 0) ||
          (technologies && technologies?.length > 0) ||
          (industries && industries?.length > 0) 
        ) &&
        <Box mt={3.125} mb={3.125} fDirection="column">
          {
            !!year &&
            <Box>
              {renderTitle(t("YEAR"))}
              <Typography
                fSize={{ md: 1.375, xxs: 1.125 }}
                lHeight={{ md: 2.125, xxs: 1.625 }}
                fWeight={400}
                color={colors.black}
              >
                {year}
              </Typography>
            </Box>
          }
          {
            services && services?.length > 0 &&
            <Box fWrap='wrap'>
              {renderTitle(t("SERVICES"))}
              {services?.map((elem: Service, index: number) => renderItem(elem.name[language], 'service', index, services.length))}
            </Box>
          }
          {
            productTypes && productTypes?.length > 0 &&
            <Box fWrap='wrap'>
              {renderTitle(t("TYPES_OF_PRODUCT"))}
              {productTypes?.map((elem: ProductType, index: number) => renderItem(elem.name[language], 'product_type', index, productTypes.length))}
            </Box>
          }
          {
            technologies && technologies?.length > 0 &&
            <Box fWrap='wrap'>
              {renderTitle(t("TYPES_OF_TECHNOLOGY"))}
              {technologies?.map((elem: Technology, index: number) => renderItem(elem.name, 'technology', index, technologies.length))}
            </Box>
          }
          {
            industries && industries?.length > 0 &&
            <Box fWrap='wrap'>
              {renderTitle(t("INDUSTRIES"))}
              {industries?.map((elem: Industry, index: number) => renderItem(elem.name[language], 'industry', index, industries.length))}
            </Box>
          }
        </Box>
      }
    </>
  );
};

export default Filters;
